import {
  type BetaServiceItem,
  betaServiceItems,
  otherServiceItems,
  popularServiceItems,
  type ServiceItem,
  type ServiceCategoryKey,
} from "../../lib";
import { View } from "@/components/ui";
import { BetaServiceIcon, ServiceIcon } from "@/components/shared/service-icon";
import { cn } from "@/lib/utils";
import type { BetaServiceName } from "@/types/service";

type ServiceCategoryGridProps = {
  category: ServiceCategoryKey;
  matchesQuery: (name: string) => boolean;
  isNarrow: boolean;
  onClickBetaService: (name: BetaServiceName, link: string) => void;
};

export function ServiceCategoryGrid({
  category,
  matchesQuery,
  isNarrow,
  onClickBetaService,
}: ServiceCategoryGridProps) {
  return (
    <View className="flex flex-row flex-wrap">
      {popularServiceItems()
        .concat(otherServiceItems())
        .filter(
          (item) =>
            item.categories.includes(category) && matchesQuery(item.title),
        )
        .map((service: ServiceItem) => (
          <View
            className={cn("px-1 pb-4", isNarrow ? "w-1/2" : "w-1/3")}
            key={service.name}
          >
            <ServiceIcon {...service} />
          </View>
        ))}
      {betaServiceItems()
        .filter(
          (item) =>
            item.categories.includes(category) && matchesQuery(item.title),
        )
        .map((service: BetaServiceItem) => (
          <View
            className={cn("h-[72px] px-1 pb-4", isNarrow ? "w-1/2" : "w-1/3")}
            key={service.name}
          >
            <BetaServiceIcon {...service} onClick={onClickBetaService} />
          </View>
        ))}
    </View>
  );
}
